export default "__VITE_PUBLIC_ASSET__7870c028__"